import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-ui-container',
  templateUrl: './setting-ui-container.component.html',
  styleUrls: ['./setting-ui-container.component.scss']
})
export class SettingUiContainerComponent implements OnInit {
  @Input() colCssClass: string = " col-md-8 col-lg-8 col-sm-12 "
  constructor() { }

  ngOnInit(): void {
  }

}
